

let minimumQuantity = 1;
const maximumQuantity = 9999;
const influenzaMaxQuantity = 99999;
const base = 10;
const zero = 0;
const one = 1;
const two = 2;
let minQuantityforInfluenza = 0;

export class ProductUtils {
  static showLimitationPopoverFor = null;
  static alterQuantity(operator, idData, quantityOfUnits): any {
    if (!isNaN(quantityOfUnits)) {
      const inputElement = document.getElementById(
        `prodQuantity${idData}`
      ) as HTMLInputElement;
      const numInputs = document.querySelectorAll('input[type=number]');
      numInputs.forEach(function (input) {
        input.addEventListener('change', function (e) {
          if ((e.target as HTMLInputElement).value === '') {
            (e.target as HTMLInputElement).value = '1';
          }
        });
      });
      const minusIcon = document.getElementById(
        `minusIcon${idData}`
      ) as HTMLElement;

      const plusIcon = document.getElementById(
        `plusIcon${idData}`
      ) as HTMLElement;
      const noOfDoses = document.getElementById(
        `noOfDoses${idData}`
      ) as HTMLInputElement;

      const unitMinus = document.getElementById(`unitMinus${idData}`);
      const unitMinusDisable = document.getElementById(
        `unitMinusDisable${idData}`
      ) as HTMLElement;

      const unitPlus = document.getElementById(`unitPlus${idData}`);
      const unitPlusDisable = document.getElementById(
        `unitPlusDisable${idData}`
      ) as HTMLElement;
      let orderValue = parseInt(inputElement.value, base);

      // inputElement value check
      const regex = new RegExp('^[0-9]{1,4}$', 'g');

      if (regex.test(inputElement.value) === true) {
        if (operator === one) {
          orderValue += 1;
        } else if (operator === two) {
          orderValue = orderValue - 1;
        } else {
          orderValue = parseInt(inputElement.value, base);
        }
        // icon chnages
        if (orderValue <= minimumQuantity) {
          minusIcon.classList.add('disabled');
          unitMinus.classList.add('disabled-img');
          unitMinusDisable.classList.remove('disabled-img');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          if (orderValue === zero) {
            orderValue = minimumQuantity;
          }
        } else if (orderValue >= maximumQuantity) {
          orderValue = maximumQuantity;
          minusIcon.classList.remove('disabled');
          unitMinus.classList.remove('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
        } else {
          minusIcon.classList.remove('disabled');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitMinus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
        }

        // noOfDoses Check
        if (inputElement.value !== '') {
          inputElement.value = orderValue.toString();
          noOfDoses.innerHTML = `${orderValue * quantityOfUnits}  Doses`;
        } else {
          noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
        }
      } else {
        if (orderValue > maximumQuantity) {
          orderValue = maximumQuantity;
          inputElement.value = maximumQuantity.toString();
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
          noOfDoses.innerHTML =
            `${orderValue * quantityOfUnits}  Doses`;
        } else {
          noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
          if (!orderValue) {
            minusIcon.classList.add('disabled');
            unitMinus.classList.add('disabled-img');
            unitMinusDisable.classList.remove('disabled-img');
            plusIcon.classList.remove('disabled');
            unitPlus.classList.remove('disabled-img');
            unitPlusDisable.classList.add('disabled-img');
          }
        }
      }
    } else {
      return false;
    }
  }
  // Custom-Prpduct Refinement Category Formatting
  static categoryFormatting(data): any {
    const value = [];
    if (data.id === one || data.id === one.toString()) {
      value.push({ name: 'All', value: data.url });
    }
    data.subcategories.forEach((obj) => {
      value.push({ name: obj.name, value: obj.url });
    });
    return value;
  }
  static alterQuantityforInfluenza(operator, idData, quantityOfUnits, page, cartFlag): any {
    if (page === 'cart') {
      minQuantityforInfluenza = 1;
    } else {

      minQuantityforInfluenza = 0;


    }
    if (!isNaN(quantityOfUnits)) {
      const inputElement = document.getElementById(
        `prodQuantity${idData}`
      ) as HTMLInputElement;
      const numInputs = document.querySelectorAll('input[type=number]');
      numInputs.forEach(function (input) {
        input.addEventListener('change', function (e) {
          if ((e.target as HTMLInputElement).value === '') {
            (e.target as HTMLInputElement).value = '1';
          }
        });
      });
      const minusIcon = document.getElementById(
        `minusIcon${idData}`
      ) as HTMLElement;

      const plusIcon = document.getElementById(
        `plusIcon${idData}`
      ) as HTMLElement;
      const noOfDoses = document.getElementById(
        `noOfDoses${idData}`
      ) as HTMLInputElement;

      const unitMinus = document.getElementById(`unitMinus${idData}`);
      const unitMinusDisable = document.getElementById(
        `unitMinusDisable${idData}`
      ) as HTMLElement;

      const unitPlus = document.getElementById(`unitPlus${idData}`);
      const unitPlusDisable = document.getElementById(
        `unitPlusDisable${idData}`
      ) as HTMLElement;
      let orderValue = parseInt(inputElement?.value, base);

      // inputElement value check
      const regex = new RegExp('^[0-9]{1,5}$', 'g');

      if (regex.test(inputElement?.value) === true) {
        if (operator === one) {
          orderValue += 1;
        } else if (operator === two && orderValue !== 0) {
          orderValue = orderValue - 1;
        } else {
          orderValue = parseInt(inputElement?.value, base);
        }
        // icon chnages 
        if (orderValue <= minQuantityforInfluenza) {
          minusIcon.classList.add('disabled');
          unitMinus.classList.add('disabled-img');
          unitMinusDisable.classList.remove('disabled-img');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          if (orderValue === -1) {
            orderValue = minQuantityforInfluenza;
          }
        } else if (orderValue >= influenzaMaxQuantity) {
          orderValue = influenzaMaxQuantity;
          minusIcon.classList.remove('disabled');
          unitMinus.classList.remove('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
        } else {
          minusIcon.classList.remove('disabled');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitMinus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
        }

        if (page === 'cart' && orderValue < 1) {
          orderValue = 1;
        }

        // noOfDoses Check
        if (inputElement.value !== '') {
          inputElement.value = orderValue?.toString();
          noOfDoses.innerHTML = `${orderValue * quantityOfUnits}  Doses`;
        } else {
          noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
        }
        if (orderValue === 0) {
          noOfDoses.innerHTML = '';
        }

      } else {
        if (orderValue > influenzaMaxQuantity) {
          orderValue = influenzaMaxQuantity;
          inputElement.value = influenzaMaxQuantity.toString();
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
          noOfDoses.innerHTML =
            `${orderValue * quantityOfUnits}  Doses`;
        } else {
          if (noOfDoses) {
            noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
          }

          if (!orderValue) {
            minusIcon?.classList.add('disabled');
            unitMinus?.classList.add('disabled-img');
            unitMinusDisable?.classList.remove('disabled-img');
            plusIcon?.classList.remove('disabled');
            unitPlus?.classList.remove('disabled-img');
            unitPlusDisable?.classList.add('disabled-img');
          }
        }
      }
    } else {
      return false;
    }

  }
  static alterNewQuantity(operator, idData, quantityOfUnits, unitType, page?): any {
    if (!isNaN(quantityOfUnits)) {
      if (page === 'flu') {
        minimumQuantity = 0;
      }
      const inputElement = document.getElementById(
        `prodQuantity${idData}`
      ) as HTMLInputElement;
      const numInputs = document.querySelectorAll('input[type=number]');
      numInputs.forEach(function (input) {
        input.addEventListener('change', function (e) {
          if ((e.target as HTMLInputElement).value === '') {
            (e.target as HTMLInputElement).value = '1';
          }
        });
      });
      const minusIcon = document.getElementById(
        `minusIcon${idData}`
      ) as HTMLElement;
      const plusIcon = document.getElementById(
        `plusIcon${idData}`
      ) as HTMLElement;
      const noOfDoses = document.getElementById(
        `noOfDoses${idData}`
      ) as HTMLInputElement;
      const unitMinus = document.getElementById(`unitMinus${idData}`);
      const unitMinusDisable = document.getElementById(
        `unitMinusDisable${idData}`
      ) as HTMLElement;
      const unitPlus = document.getElementById(`unitPlus${idData}`);
      const unitPlusDisable = document.getElementById(
        `unitPlusDisable${idData}`
      ) as HTMLElement;
      let orderValue: any;
      if (inputElement)
        orderValue = parseInt(inputElement.value, base);
      // inputElement value check
      const regex = new RegExp('^[0-9]{1,4}$', 'g');
      if (regex.test(inputElement?.value)) {
        if (operator === one) {
          orderValue += 1;
        } else if (operator === two) {
          orderValue = orderValue - 1;
        } else {
          orderValue = parseInt(inputElement.value, base);
        }
        // icon chnages
        if (orderValue <= minimumQuantity) {
          minusIcon.classList.add('disabled');
          unitMinus.classList.add('disabled-img');
          unitMinusDisable.classList.remove('disabled-img');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          if (orderValue === zero) {
            orderValue = minimumQuantity;
          }
        } else if (orderValue >= maximumQuantity) {
          orderValue = maximumQuantity;
          minusIcon.classList.remove('disabled');
          unitMinus.classList.remove('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
        } else {
          minusIcon.classList.remove('disabled');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitMinus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
        }
        // noOfDoses Check
        if (inputElement.value !== '') {
          inputElement.value = orderValue.toString();
          if (noOfDoses)
            noOfDoses.innerHTML = `${orderValue * quantityOfUnits}` + ` ` + unitType;
        } else {
          if (noOfDoses)
            noOfDoses.innerHTML = `${quantityOfUnits}` + ` ` + unitType;
        }
      } else {
        if (orderValue > maximumQuantity) {
          orderValue = maximumQuantity;
          inputElement.value = maximumQuantity.toString();
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
          noOfDoses.innerHTML =
            `${orderValue * quantityOfUnits}  ${unitType}`;
        } else {
          //noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
          if (noOfDoses)
            // noOfDoses.innerHTML = `${0}  Doses`;
            noOfDoses.innerHTML = `${quantityOfUnits}` + ` ` + unitType;
          if (!orderValue) {
            minusIcon?.classList.add('disabled');
            unitMinus?.classList.add('disabled-img');
            unitMinusDisable?.classList.remove('disabled-img');
            plusIcon?.classList.remove('disabled');
            unitPlus?.classList.remove('disabled-img');
            unitPlusDisable?.classList.add('disabled-img');
          }
        }
      }
    } else {
      return false;
    }
  }

  static alterNewQuantityFlu(operator, idData, quantityOfUnits, unitType, page?): any {
    if (!isNaN(quantityOfUnits)) {
      if (page === 'flu') {
        minimumQuantity = 0;
      }
      const inputElement = document.getElementById(
        `prodQuantity${idData}`
      ) as HTMLInputElement;
      const numInputs = document.querySelectorAll('input[type=number]');
      numInputs.forEach(function (input) {
        input.addEventListener('change', function (e) {
          if ((e.target as HTMLInputElement).value === '') {
            (e.target as HTMLInputElement).value = '1';
          }
        });
      });
      const minusIcon = document.getElementById(
        `minusIcon${idData}`
      ) as HTMLElement;
      const plusIcon = document.getElementById(
        `plusIcon${idData}`
      ) as HTMLElement;
      const noOfDoses = document.getElementById(
        `noOfDoses${idData}`
      ) as HTMLInputElement;
      const unitMinus = document.getElementById(`unitMinus${idData}`);
      const unitMinusDisable = document.getElementById(
        `unitMinusDisable${idData}`
      ) as HTMLElement;
      const unitPlus = document.getElementById(`unitPlus${idData}`);
      const unitPlusDisable = document.getElementById(
        `unitPlusDisable${idData}`
      ) as HTMLElement;
      let orderValue: any;
      if (inputElement)
        orderValue = parseInt(inputElement?.value, base);
      // inputElement value check
      const regex = new RegExp('^[0-9]{1,5}$', 'g');
      if (regex.test(inputElement?.value)) {
        if (operator === one) {
          orderValue += 1;
        } else if (operator === two && orderValue !== 0) {
          orderValue = orderValue - 1;
        } else {
          orderValue = parseInt(inputElement?.value, base);
        }
        // icon chnages
        if (orderValue <= minimumQuantity) {
          minusIcon.classList.add('disabled');
          unitMinus.classList.add('disabled-img');
          unitMinusDisable.classList.remove('disabled-img');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          if (orderValue === zero || orderValue === -1) {
            orderValue = minimumQuantity;
          }
        } else if (orderValue >= influenzaMaxQuantity) {
          orderValue = influenzaMaxQuantity;
          minusIcon.classList.remove('disabled');
          unitMinus.classList.remove('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
        } else {
          minusIcon.classList.remove('disabled');
          plusIcon.classList.remove('disabled');
          unitPlus.classList.remove('disabled-img');
          unitMinus.classList.remove('disabled-img');
          unitPlusDisable.classList.add('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
        }
        // noOfDoses Check
        if (inputElement.value !== '') {
          inputElement.value = orderValue?.toString();
          if (noOfDoses)
            noOfDoses.innerHTML = `${orderValue * quantityOfUnits}` + ` ` + unitType;
        } else {
          if (noOfDoses)
            noOfDoses.innerHTML = `${quantityOfUnits}` + ` ` + unitType;
        }
      } else {
        if (orderValue > influenzaMaxQuantity) {
          orderValue = influenzaMaxQuantity;
          inputElement.value = influenzaMaxQuantity?.toString();
          minusIcon.classList.remove('disabled');
          unitMinus.classList.remove('disabled-img');
          unitMinusDisable.classList.add('disabled-img');
          plusIcon.classList.add('disabled');
          unitPlus.classList.add('disabled-img');
          unitPlusDisable.classList.remove('disabled-img');
          noOfDoses.innerHTML =
            `${orderValue * quantityOfUnits}  ${unitType}`;
        } else {
          //noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
          if (noOfDoses)
            // noOfDoses.innerHTML = `${0}  Doses`;
            noOfDoses.innerHTML = `${quantityOfUnits}` + ` ` + unitType;
          if (!orderValue) {
            minusIcon?.classList.add('disabled');
            unitMinus?.classList.add('disabled-img');
            unitMinusDisable?.classList.remove('disabled-img');
            plusIcon?.classList.remove('disabled');
            unitPlus?.classList.remove('disabled-img');
            unitPlusDisable?.classList.add('disabled-img');
          }
        }
      }
    } else {
      return false;
    }
  }

  static computeQuantityForAllocated(operator, idData, quantityOfUnits, unitType, availableQty,isModal?) {
    const minimumQuantity = 1;
    if (!isNaN(quantityOfUnits)) {
      const inpId = isModal ? 'prodQuantity'+idData+'-modal': 'prodQuantity'+idData;
      const minusId= isModal ? 'unitMinus'+idData+'-modal' : 'unitMinus'+idData;
      const plusId = isModal ? 'unitPlus'+idData+'-modal': 'unitPlus'+idData;
      const countId = isModal ? 'noOfDoses'+idData+'-modal' : 'noOfDoses'+idData;
      const inputElement = document.getElementById(inpId) as HTMLInputElement;

      inputElement?.addEventListener('change', event => {
        if (['','0'].includes(inputElement?.value)) {
          inputElement.value = "" + minimumQuantity;
          minusbtn.classList.add('disabled-image');
          plusBtn.classList.remove('disabled-image');
          dosesCountLabel.innerHTML = `${quantityOfUnits} ${unitType}`;
        }
      });

      const minusbtn = document.getElementById(
        minusId
      ) as HTMLElement;
      const plusBtn = document.getElementById(
       plusId
      ) as HTMLElement;
      const dosesCountLabel = document.getElementById(
        countId
      ) as HTMLInputElement;
      if (new RegExp('^[0-9]{1,}$', 'g').test(inputElement?.value)) {

        if (operator == one) {
          inputElement.value = "" + (+inputElement.value + 1);
        }
        else if (operator == two) {
          inputElement.value = "" + (+inputElement.value - 1);
        }

        if (+inputElement.value > minimumQuantity){
          [minusbtn, plusBtn].forEach(el => el.classList.remove('disabled-image'));
          inputElement.style.color = '#313131';
        }   
         
        if (+inputElement.value >= maximumQuantity) {
          inputElement.value = "" + maximumQuantity;
          inputElement.style.color = '#de1848';
          plusBtn.classList.add('disabled-image');
          minusbtn.classList.remove('disabled-image');
        }

        if (availableQty != null && availableQty >= 0) {
          if(availableQty >= 1){
            if(+inputElement.value > availableQty){
              inputElement.style.color = '#de1848';
              plusBtn.classList.add('disabled-image');
              minusbtn.classList.remove('disabled-image');
              this.showLimitationPopoverFor = idData; 
              }
              else {
              inputElement.style.color = '#313131';
              plusBtn.classList.remove('disabled-image');
              this.showLimitationPopoverFor = null;
            } 
          }
          else{
            inputElement.value = '0';
            inputElement.style.color = '#de1848';
            [minusbtn, plusBtn].forEach(el => el.classList.add('disabled-image'));
            this.showLimitationPopoverFor = idData; 
          }
        }
        else{
          this.showLimitationPopoverFor = null; 
          if(['0','1'].includes(inputElement.value)){
            inputElement.value = "" + minimumQuantity;
            inputElement.style.color = '#313131';
            minusbtn.classList.add('disabled-image');
            plusBtn.classList.remove('disabled-image');
          } 
        }
        dosesCountLabel.innerHTML = `${+inputElement.value * quantityOfUnits} ${unitType}`;
      }
    }
    else {
      return false;
    }
  }

  static computeQuantityForAllocatedQuickAdd(operator, idData, quantityOfUnits, unitType, availableQty,isModal?) {
    if (!isNaN(quantityOfUnits)) {
      const inpId = isModal ? 'prodQuantityQuick'+idData+'-modal': 'prodQuantityQuick'+idData;
      const minusId= isModal ? 'unitMinusQuick'+idData+'-modal' : 'unitMinusQuick'+idData;
      const plusId = isModal ? 'unitPlusQuick'+idData+'-modal': 'unitPlusQuick'+idData;
      const countId = isModal ? 'noOfDosesQuick'+idData+'-modal' : 'noOfDosesQuick'+idData;
      const inputElement = document.getElementById(inpId) as HTMLInputElement;

      inputElement?.addEventListener('change', event => {
        if ([''].includes(inputElement?.value)) {
          inputElement.value = "" + minimumQuantity;
          minusbtn.classList.add('disabled-image');
          plusBtn.classList.remove('disabled-image');
          dosesCountLabel.innerHTML = `${quantityOfUnits} ${unitType}`;
        }
      });

      const minusbtn = document.getElementById(
        minusId
      ) as HTMLElement;
      const plusBtn = document.getElementById(
       plusId
      ) as HTMLElement;
      const dosesCountLabel = document.getElementById(
        countId
      ) as HTMLInputElement;
      if (new RegExp('^[0-9]{1,}$', 'g').test(inputElement?.value)) {

        if (operator == one) {
          inputElement.value = "" + (+inputElement.value + 1);
        }
        else if (operator == two) {
          inputElement.value = "" + (+inputElement.value - 1);
        }

        if (+inputElement.value > minimumQuantity){
          [minusbtn, plusBtn].forEach(el => el.classList.remove('disabled-image'));
          inputElement.style.color = '#313131';
        }   
         
        if (+inputElement.value >= maximumQuantity) {
          inputElement.value = "" + maximumQuantity;
          inputElement.style.color = '#de1848';
          plusBtn.classList.add('disabled-image');
          minusbtn.classList.remove('disabled-image');
        }

        if (availableQty != null && availableQty >= 0) {
          if(availableQty >= 1){
            if(+inputElement.value > availableQty){
              inputElement.style.color = '#de1848';
              plusBtn.classList.add('disabled-image');
              minusbtn.classList.remove('disabled-image');
              this.showLimitationPopoverFor = idData; 
              }
              else {
              inputElement.style.color = '#313131';
              plusBtn.classList.remove('disabled-image');
              this.showLimitationPopoverFor = null;
            } 
          }
          else{
            inputElement.value = '0';
            inputElement.style.color = '#de1848';
            [minusbtn, plusBtn].forEach(el => el.classList.add('disabled-image'));
            this.showLimitationPopoverFor = idData; 
          }
           
        }
        

        if (+inputElement.value == zero && (availableQty == null || !!availableQty)) {
          inputElement.value = "" + minimumQuantity;
          minusbtn.classList.add('disabled-image');
          plusBtn.classList.remove('disabled-image');
          dosesCountLabel.innerHTML = `${quantityOfUnits} ${unitType}`;
        }
        else {
          dosesCountLabel.innerHTML = `${+inputElement.value * quantityOfUnits} ${unitType}`;
        }
      }
    }
    else {
      return false;
    }
  }
}
